<section class="success-story">
	<div class="container">
		<div class="row">
			<div class="col-md-11 col-sm-11 col-11 mx-auto">
				<div class="content mbrem8"></div>
				<owl-carousel-o [options]="desktopslider">
					<ng-container *ngFor="let testimonial of testimonials">
						<ng-template carouselSlide [id]="baseUrl">
							<div class="col-md-9 col-sm-12 col-12 mx-auto">
								<div class="row">
									<div class="col-lg-3 col-md-5 col-sm-5">
										<div class="imgblk">
											<img
												class=""
												src="{{ imagepath }}/testimonial/{{
													testimonial.image
												}}"
												alt="web development dubai"
												width="204"
												height="408"
												loading="lazy"
											/>
										</div>
									</div>
									<div
										class="col-lg-8 col-md-7 offset-lg-1 col-sm-7 mt-sm-0 mt-3"
									>
										<div class="slidecontent">
											<h3
												class="fontsize12 semibold textcolor1 m-0"
												[ngClass]="{ textcolor1: isWhiteText }"
											>
												{{ testimonial.name }}
											</h3>
											<h4
												class="size32 textcolor1 medium m-0 text-uppercase"
												style="
													margin-top: 10px !important;
													margin-bottom: 5px !important;
												"
												[ngClass]="{ textcolor1: isWhiteText }"
											>
												{{ testimonial.title }}
											</h4>
											<div
												class="text-container"
												[class.expanded]="testimonial.isExpanded"
											>
												<p
													class="size20 textcolor3 d-md-block d-sm-none d-none"
													[ngClass]="{ textcolor1: isWhiteText }"
												>
													{{
														testimonial.isExpanded
															? testimonial.text
															: (testimonial.text | slice : 0 : 240) + "..."
													}}
												</p>
											</div>
											<span
												class="show-more-btn d-md-block d-sm-none d-none hover-underline-animation lufgaregular size18"
												(click)="toggleText(testimonial)"
											>
												{{ testimonial.isExpanded ? "Read Less" : "Read More" }}
											</span>
										</div>
									</div>
									<div class="col-md-12 d-md-none d-sm-block d-block mt-sm-4">
										<div class="slidecontent">
											<div
												class="text-container"
												[class.expanded]="testimonial.isExpanded"
											>
												<p
													class="size20 textcolor3 csttext1"
													[ngClass]="{ textcolor1: isWhiteText }"
												>
													{{ testimonial.text }}
												</p>
											</div>
											<span
												class="show-more-btn d-md-none d-sm-block d-block hover-underline-animation lufgaregular size18"
												(click)="toggleText(testimonial)"
											>
												{{ testimonial.isExpanded ? "Show Less" : "Show More" }}
											</span>
										</div>
									</div>
								</div>
							</div>
						</ng-template>
					</ng-container>
				</owl-carousel-o>
			</div>
		</div>
	</div>
</section>
